import React from "react";
import ValidationScoreBoard from "./ValidationScoreBoard";

export const ValidationScoreBoardContext =
  React.createContext<ValidationScoreBoard | null>(null);
